import React, { useState } from "react";
import { toast } from "sonner";
import { ShareNetwork, DownloadSimple, LinkSimple } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function ShareStreak() {
  const [info, setInfo] = useState(null);
  const [img, setImg] = useState(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const [i, c] = await Promise.all([api.get("/app/share"), api.get("/app/share/card", { responseType: "blob" })]);
      const blob = new Blob([c.data], { type: "image/png" });
      setInfo(i.data); setImg(URL.createObjectURL(blob)); setFile(new File([blob], "exodus-streak.png", { type: "image/png" }));
    } catch (e) { toast.error(e?.response?.status === 403 ? "Reach a 7-check-in streak to unlock your share card." : "Could not create your card."); }
    finally { setBusy(false); }
  };
  const share = async () => {
    const data = { title: "My Exodus streak", text: info.text, url: info.url };
    try {
      if (navigator.canShare?.({ files: [file] })) await navigator.share({ ...data, files: [file] });
      else if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(`${info.text} ${info.url}`); toast.success("Link copied — paste it anywhere."); }
    } catch { /* user cancelled */ }
  };
  const download = () => { const a = Object.assign(document.createElement("a"), { href: img, download: "exodus-streak.png" }); document.body.appendChild(a); a.click(); a.remove(); };
  const copy = async () => { try { await navigator.clipboard.writeText(info.url); toast.success("Link copied."); } catch { toast.error(info.url); } };

  if (!info) {
    return <button data-testid="share-streak-open" onClick={open} disabled={busy} className="btn-ghost text-xs"><ShareNetwork size={16} /> {busy ? "Creating…" : "Share my streak"}</button>;
  }
  return (
    <div data-testid="share-streak-panel" className="w-full mt-2 flex flex-col gap-4">
      <img data-testid="share-streak-image" src={img} alt="Your streak card" className="w-44 h-44 border border-exodus-border" />
      <div className="space-y-3">
        <p className="text-xs text-exodus-muted">Friends who use your link land on Find My Fit.</p>
        <div className="flex flex-wrap gap-2">
          <button data-testid="share-streak-share" onClick={share} className="btn-gold text-xs"><ShareNetwork size={16} /> Share</button>
          <button data-testid="share-streak-download" onClick={download} className="btn-ghost text-xs"><DownloadSimple size={16} /> Download</button>
          <button data-testid="share-streak-copy" onClick={copy} className="btn-ghost text-xs"><LinkSimple size={16} /> Copy link</button>
        </div>
        <p data-testid="share-streak-url" className="text-[11px] gold-text break-all">{info.url}</p>
      </div>
    </div>
  );
}
